import React, { useState, useMemo } from "react";
import CustomRadioGroup from "../RadioGroup";
import RadioButton from "../RadioGroup/RadioButton";
import classes from "./PositionCodeAssign.module.css";
import Button from "../Button";

export const MARKET = 'Market';
export const CATEGORY = 'Category';
export const CONTEXT = 'Context';
export const Lending = 'Lending';

const PositionCodeAsign = ({ positionCodeData, onAsignPositionCodeFn, isLoading }) => {
  const [selectedValue, setSelectedValue] = useState('');
  const handleRadioChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const onAsignPositionCode = () => {
    onAsignPositionCodeFn(selectedValue);
  };

  const headers = useMemo(() => {
    if (!positionCodeData?.length) return [];
    const headersSet = new Set();
    positionCodeData?.forEach((item) => {
      item?.positionCodeAdditionalDetails?.forEach((detail) => {
        headersSet.add(detail?.refType);
      });
    });
    return Array.from(headersSet);
  }, [positionCodeData]);

  const gridColumns = useMemo(
    () => `repeat(${headers?.length}, 1fr)`,
    [headers.length]
  );
  const dynamicGap = useMemo(
    () => `${Math.min(30, 100 / headers?.length)}px`,
    [headers.length]
  );

  const getDynamicRefValues = (data) => {
    return data?.positionCodeAdditionalDetails?.reduce((acc, current) => {
      acc[current.refType] = current.refValue;
      return acc;
    }, {}) || {};
  };

  return (
    <div
      style={{
        padding: "2rem",
        maxHeight: '90vh',
        overflow: 'auto'
      }}
    >
      <div className={classes["position-code-asign-wrapper"]}
        style={{
          display: "grid",
          gridTemplateColumns: gridColumns,
          gap: dynamicGap,
        }}
      >
        {headers?.map((header, index) => (
          <span key={index} style={{ fontWeight: "bold" }}>{header}</span>
        ))}
      </div>
      <CustomRadioGroup
        className={classes["radio-button-text-color"]}
        selectedValue={selectedValue}
        onChange={handleRadioChange}
      >
        {positionCodeData?.length ? positionCodeData?.map((pcd, i) =>
        {
          const refValues = getDynamicRefValues(pcd);
          return (
            <RadioButton
              key={'PositionCodeDetails ' + i}
              name={"PositionCodeDetails" + i}
              id={"PositionCodeDetails" + i}
              value={JSON.stringify(pcd?.id)}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: gridColumns,
                  gap: dynamicGap,
                }}
              >
                {headers?.map((header, index) => (
                  <span key={index}>{refValues[header]}</span>
                ))}
              </div>
            </RadioButton>
          );
        }) : <p style={{ textAlign: "center", fontWeight: "bold" }}>No Data</p>}
      </CustomRadioGroup>

      <div style={{ textAlign: "center", marginTop: "1rem" }}>
        <Button disabled={!selectedValue || isLoading} onClick={onAsignPositionCode}>
          {isLoading ? 'Loading' : 'Done'}
        </Button>
      </div>
    </div>
  );
};

export default PositionCodeAsign;
